import React from "react";
import { Button } from "components/common/Button";
interface NotificationSettingsActionsProps {
  hasChanges: boolean;
  saving: boolean;
  onCancel: () => void;
  onSave: () => void;
}

export const NotificationSettingsActions: React.FC<
  NotificationSettingsActionsProps
> = ({ hasChanges, saving, onCancel, onSave }) => {
  return (
    <div className="flex justify-end gap-2 mt-3">
      <Button
        onClick={onCancel}
        disabled={saving || !hasChanges}
        variant="secondary"
        size="md"
      >
        {" "}
        Cancel
      </Button>
      <Button
        onClick={onSave}
        disabled={saving || !hasChanges}
        variant="primary"
        size="md"
      >
        {" "}
        Save
      </Button>
    </div>
  );
};
